import styled, { css } from "styled-components";

const GridContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: ${(props) => props.gap || 16}px;
  width: 100%;
  justify-items: start;

  ${(props) =>
    props.maxColumns &&
    css`
      @media (min-width: 768px) {
        grid-template-columns: repeat(
          auto-fit,
          minmax(${(props) => props.minWidth || 200}px, 1fr)
        );
      }

      @media (min-width: 1024px) {
        grid-template-columns: repeat(
          ${(props) => props.maxColumns},
          minmax(${(props) => props.minWidth || 200}px, 1fr)
        );
      }
    `}
`;

export const GridComponent = ({
  children,
  gap = 16,
  minWidth = 200,
  maxColumns = 4,
  style = {},
}) => {
  return (
    <GridContainer
      gap={gap}
      minWidth={minWidth}
      maxColumns={maxColumns}
      style={{
        justifyContent: "flex-start",
        ...style,
      }}
    >
      {children}
    </GridContainer>
  );
};
